import React from 'react';

import { basesUrl } from '@/lib/BasesUrl';
import arrowDownIcon from '@/static/images/arrowdown.svg';
import { changeLocation, classNames } from '@/shared/helpers';
import type { IStaticLocale } from '@/interfaces/staticlocale';
import type { IFinalProductProps } from '@/interfaces/products';

import './styles.scss';

type Props = {
  lang: string;
  pathLang: string;
  locale: IStaticLocale;
  shouldApplyContrast: boolean;
  products: IFinalProductProps[];
  shouldDisplayProductsPage: boolean;
};

const ProductItems = (props: Props) => {
  const {
    locale,
    lang,
    pathLang,
    products,
    shouldApplyContrast,
    shouldDisplayProductsPage,
  } = props;

  const prefixPath = pathLang === '' ? pathLang : `/${lang}`;

  return (
    <li className="navbar-list-item">
      <button
        onClick={() =>
          shouldDisplayProductsPage
            ? changeLocation(`/${pathLang}${basesUrl.products}`)
            : null
        }
        className={classNames(
          'main-content',
          shouldApplyContrast ? 'text-with-contrast' : 'text-without-contrast'
        )}
      >
        <p>{locale.header.products}</p>
        <img
          className={classNames(
            shouldApplyContrast ? 'image-with-contrast' : ''
          )}
          src={arrowDownIcon}
          alt={locale.header.arrow_down_icon}
        />
      </button>

      <div className="anim-drop-down submenu">
        {products.map(({ id, name, currentPath }) => (
          <a
            className="anim-drop-down-item"
            key={id}
            href={`${prefixPath}${currentPath}`}
          >
            {name}
          </a>
        ))}
      </div>
    </li>
  );
};

export default ProductItems;
